export const Option = Object.freeze({
	BookingEnabled: 'aha_banner',
	IntersectionForAll: 'IntersectionForAll',
	WaitListExpanded: 'wait_list_expanded',
	CalendarExpanded: 'calendar_expanded',
	NotificationsExpanded: 'notificationsExpanded',

	// AhaMoments
	AhaBanner: 'aha_banner',
	AhaTrialBanner: 'aha_trial_banner',
	AhaAddResource: 'aha_add_resource',
	AhaMessageTemplate: 'aha_message_template',
	AhaAddClient: 'aha_add_client',
	AhaResourceWorkload: 'aha_resource_workload',
	AhaResourceIntersection: 'aha_resource_intersection',
	AhaExpandGrid: 'aha_expand_grid',
	AhaSelectResources: 'aha_select_resources',
	AhaCyclePopup: 'aha_cycle_popup',
	AhaSearchNavigation: 'aha_search_navigation',
});
